import React, { Component } from 'react'
import _ from 'lodash'
import { Label, Popup, Header, Form, Image, Dimmer, Loader } from 'semantic-ui-react'

import AddCategory from './AddCategory'

export default class CategoryList extends Component {
  state = {
    imageLoaded: false,
  }

  renderMenuCategories = () => {
    const { imageLoaded } = this.state
    const { onChange, selected, menu, openFileUpload, menuKey } = this.props

    const categoriesList = _.map(menu.categories, (category, key) => {
      const imageUrl = category.image || require('../../../assets/images/placeholder.png')

      return (
        <Popup
          trigger={
            <Form.Checkbox
              key={key}
              label={category.name}
              onChange={() => onChange(key)}
              checked={_.includes(selected, key)}
              style={{ marginTop: 6, marginBottom: 6 }}
            />
          }
          onOpen={() => this.setState({ imageLoaded: true })}
          position="top center"
          hoverable
        >
          <Form.Field>
            <Image
              src={imageUrl}
              style={{ marginLeft: 50 }}
              className="image-previewer-category"
              onLoad={() => this.setState({ imageLoaded: false })}
              onClick={() => openFileUpload(menuKey, key)}
              dimmer={
                <Dimmer active={imageLoaded}>
                  <Loader />
                </Dimmer>
              }
            />
          </Form.Field>
          Key: <Label style={{ marginTop: 5, marginLeft: 5 }}>{key}</Label>
        </Popup>
      )
    })

    return <div className="categories-select">{categoriesList}</div>
  }

  render() {
    const { menu } = this.props

    return (
      <div>
        <div
          style={{
            marginTop: 10,
            marginBottom: 10,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Header size="small" style={{ margin: 0 }}>
            {`${menu.name} (${_.size(menu.categories)})`}
          </Header>
          <AddCategory {...this.props} />
        </div>
        <div>{this.renderMenuCategories()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/category/components/CategoryList.js